export const AppStoreRedirectRoutesDeprecated = {
    ROOT: "/georgeapp-backup"
};


// WEBPACK FOOTER //
// ./src/components/appStoreRedirectDeprecated/AppStoreRedirectRoutesDeprecated.ts